import { gql } from '@apollo/client';

export const fetchAssociatedBillingAccounts = gql`
  query fetchAssociatedBillingAccounts($id: ID!, $currency: String) {
    transactionAccount(id: $id) {
      id
      billingAccountsList(currency: $currency) {
        totalCount
        totalCreditLimit
        creditOutstanding
        availableCreditLimit
        paymentMethod
        currency
        status
        nodes {
          creditOutstanding
          status
          customerName
          transactionAccountNumber
          transactionAccountId
          pendingInvoiceRequestsTotal
          taxId
        }
      }
    }
  }
`;
